import React, { useState } from "react";

import BottomSheet from "../bottom_sheet/BottomSheet";

import MealTrial from "./MealTrial";
import { MealCard } from "./MealCard";
import { ReplacementModal } from "./ReplacementModal";

import "./meals.scss";

const Meals = (params) => {
  const {
    mealsItems,
    data,
    activeUserSubscription,
    isExpired,
    sync,
    trial,
    changeDay,
    activeDate,
  } = params;

  const [isLoading1, setIsLoading1] = useState(params.isLoading);
  const [replacementModalStatus, setReplacementModalStatus] = useState(false);
  const [replacementModalTitle, setReplacementModalTitle] =
    useState(" لیست وعده ها");
  const [activeFreeMeals, setActiveFreeMeals] = useState(null);
  const [activeMeal, setActiveMeal] = useState(null);
  const [selectedFreeMeal, setSelectedFreeMeal] = useState(null);
  const [bottomSheetConfig, setBottomSheetConfig] = useState({});
  const { showCalorieStatus } = params;

  function bottomSheetHandler(config) {
    setBottomSheetConfig(config);
  }

  const isFasting = data.day_meals[activeDate]?.label === "فستینگ";

  return (
    <>
      {trial ? <MealTrial data={trial} changeDay={changeDay} /> : ""}
      <div
        className={`meals !grid grid-cols-1 lg:!gap-6 lg:grid-cols-2 ${
          trial ? "trial-meals" : ""
        }`}
      >
        {mealsItems.map((meal, mealIndex) => {
          return (
            <MealCard
              isFasting={isFasting}
              showCalorieStatus={showCalorieStatus}
              meal={meal}
              mealIndex={mealIndex}
              activeUserSubscription={activeUserSubscription}
              isExpired={isExpired}
              openReplaceModal={openReplaceModal}
              bottomSheetConfig={bottomSheetConfig}
              bottomSheetHandler={bottomSheetHandler}
            />
          );
        })}
      </div>

      <BottomSheet
        bottomSheetConfig={bottomSheetConfig}
        bottomSheetHandler={bottomSheetHandler}
      />

      <ReplacementModal
        replacementModalStatus={replacementModalStatus}
        closeReplaceModal={closeReplaceModal}
        replacementModalTitle={replacementModalTitle}
        activeFreeMeals={activeFreeMeals}
        replaceModalSearch={replaceModalSearch}
        selectFreeMeal={selectFreeMeal}
        isLoading1={isLoading1}
        selectedFreeMeal={selectedFreeMeal}
        activeMeal={activeMeal}
        sync={sync}
        setIsLoading1={setIsLoading1}
        handleNotfound={handleNotfound}
      />
    </>
  );

  function openReplaceModal(meal) {
    setActiveFreeMeals(null);
    setReplacementModalStatus(true);
    setSelectedFreeMeal(null);
    setActiveMeal(meal);
    setActiveFreeMeals(
      data.free_meals
        .filter((freeMeal) => freeMeal.meal_type_id === meal.meal_type_id)
        .flat()
    );
    setReplacementModalTitle(` لیست وعده های ${meal.meal_type}`);
  }

  function replaceModalSearch(value) {
    if (value.length <= 1) {
      setActiveFreeMeals(
        data.free_meals
          .filter(
            (freeMeal) => freeMeal.meal_type_id === activeMeal.meal_type_id
          )
          .flat()
      );
    }

    const meals = data.free_meals
      .filter((freeMeal) => freeMeal.meal_type_id === activeMeal.meal_type_id)
      .flat();
    const result = meals
      .filter((activeFreeMeal) => {
        const summaries = activeFreeMeal.foods
          .map((food) => food.summary)
          .join(" ");
        return summaries.includes(value);
      })
      .flat();

    setActiveFreeMeals(result);
  }

  function selectFreeMeal(freeMeal) {
    setSelectedFreeMeal(freeMeal);
  }

  function closeReplaceModal() {
    setReplacementModalStatus(false);
  }

  function handleNotfound() {
    localStorage.setItem("error", "PageNotFound");
    setIsLoading1(false);
    window.location.href = "";
  }
};
export default Meals;
